var SCM = SCM || {};

(function (ns, $) {
    var config = {
        carouselSelector: '.cover-carousel',
        itemSelector: '.carousel-item',
        mainImageSelector: '.main-cover-image',
        navigationPrevSelector: '.carousel-nav.prev',
        navigationNextSelector: '.carousel-nav.next',
        captionSelector: '.cover-caption',
        downloadButtonSelector: '.download-button',
        activeClass: 'active',
    };

    var state = {
        currentIndex: 0,
        isAnimating: false
    };

    function initCarousel(container) {
        var $container = $(container);
        var $carousel = $container.find(config.carouselSelector);
        if (!$carousel.length) {
            return;
        }

        var configuredSlots = parseInt($carousel.data('carousel-slots'), 10);
        var totalItems = $carousel.find(config.itemSelector).length;
        var visibleSlots = Math.min(configuredSlots, totalItems);

        // Carousel dimensions
        var gapPx = 12; // space between items in px
        var itemWidthPx = 42;

        // Calculate width based on actual number of visible slots
        var carouselWidthPx = (itemWidthPx * visibleSlots) + (gapPx * (visibleSlots - 1)) + 1;
        $carousel.css('width', carouselWidthPx + 'px');

        state.slots = visibleSlots;
        state.itemWidth = itemWidthPx;
        state.itemGap = gapPx;

        bindEvents(container);
        updateUI(container);
    }

    function bindEvents(container) {
        var $container = $(container);

        $container.find(config.itemSelector).on('click', function () {
            selectCover(container, this);
        });

        $container.find(config.navigationPrevSelector).on('click', function () {
            navigate(container, 'prev');
        });

        $container.find(config.navigationNextSelector).on('click', function () {
            navigate(container, 'next');
        });

        // Keyboard navigation
        $container.find(config.carouselSelector).on('keydown', function (e) {
            if (e.key === 'ArrowLeft') navigate(container, 'prev');
            if (e.key === 'ArrowRight') navigate(container, 'next');
        });

        $container.find(config.downloadButtonSelector).on('click', function (e) {
            e.preventDefault();
            var multimediaId = $(this).data('multimedia-id');
            if (!multimediaId) {
                return;
            }
            window.location.href = '/api/coverdownload?multimediaId=' + multimediaId;
        });

    }

    function navigate(container, direction) {
        if (state.isAnimating) {
            return;
        }

        var $items = $(container).find(config.itemSelector);
        var maxIndex = Math.max(0, $items.length - state.slots);

        if (direction === 'prev' && state.currentIndex > 0) {
            state.currentIndex--;
        } else if (direction === 'next' && state.currentIndex < maxIndex) {
            state.currentIndex++;
        }

        updateUI(container);
    }

    function updateUI(container) {
        updateCarouselPosition(container);
        updateNavigationState(container);
    }

    function updateCarouselPosition(container) {
        var $carousel = $(container).find(config.carouselSelector);
        var offset = -(state.currentIndex * (state.itemWidth + state.itemGap));

        $carousel.css({
            transform: `translateX(${offset}px)`,
        });
    }

    function updateNavigationState(container) {
        var $container = $(container);
        var $items = $container.find(config.itemSelector);
        var maxIndex = Math.max(0, $items.length - state.slots);

        var $prevBtn = $container.find(config.navigationPrevSelector);
        var $nextBtn = $container.find(config.navigationNextSelector);

        $prevBtn.prop('disabled', state.currentIndex <= 0)
            .attr('aria-disabled', state.currentIndex <= 0);

        $nextBtn.prop('disabled', state.currentIndex >= maxIndex)
            .attr('aria-disabled', state.currentIndex >= maxIndex);
    }

    function selectCover(container, item) {
        if (!item || state.isAnimating) {
            return;
        }

        var $container = $(container);
        var $items = $container.find(config.itemSelector);
        var $item = $(item);

        $items.removeClass(config.activeClass);
        $item.addClass(config.activeClass);

        updateMainImage($container, $item);
        updateCaption($container, $item);
    }

    function updateMainImage($container, $item) {
        var $mainImage = $container.find(config.mainImageSelector);
        if (!$mainImage.length) {
            return;
        }

        var coverUrl = $item.data('cover-url');
        var multimediaId = $item.data('cover-id');

        var $downloadButton = $container.find(config.downloadButtonSelector);
        if ($downloadButton.length) {
            $downloadButton.data('multimedia-id', multimediaId);
        }

        var newImage = new Image();
        newImage.onload = function () {
            $mainImage.attr({
                'src': coverUrl,
                'alt': $item.find('img').attr('alt')
            });
        };
        newImage.src = coverUrl;
    }

    function updateCaption($container, $item) {
        var $caption = $container.find(config.captionSelector);
        if (!$caption.length) {
            return;
        }

        var caption = $item.data('cover-caption');
        if (caption) {
            $caption.html(caption);
        }
    }

    ns.init = function () {
        $('.multiple-cover-issue-info-wrap').each(function () {
            initCarousel(this);
        });
    };

})(SCM.MultipleCoverIssue = SCM.MultipleCoverIssue || {}, jQuery);

(function ($) {
    $(function () {
        SCM.MultipleCoverIssue.init();
    });
})(jQuery);